import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommentsModule } from '@helios/comments'
import { FilterModalModule } from '@helios/filter-modal'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbDropdownModule,
  NgbModalModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import {
  GridWrapperModule,
  RowActionsModule,
  TableLayoutModule,
} from '@northfork/ag-grid-angular'
import {
  ButtonModule,
  DateModule,
  DatepickerModule,
  DaterangeModule,
  InlineEditModule,
  LoaderModule,
  NfFormsModule,
  TableModule,
  ToastModule,
} from '@northfork/ng-basics'
import { AccountListAggregateDropdownComponent } from './account-list-grid/account-list-aggregate-dropdown/account-list-aggregate-dropdown.component'
import { AccountListFilterActionsComponent } from './account-list-grid/account-list-filter-actions/account-list-filter-actions'
import { AccountListGridComponent } from './account-list-grid/account-list-grid.component'
import { BulkRunFilteredAccountsConfirmationModal } from './account-list-grid/bulk-run-filtered-accounts-modals/bulk-run-filtered-accounts-confirmation/bulk-run-filtered-accounts-confirmation'
import { BulkRunFilteredAccountsComponent } from './account-list-grid/bulk-run-filtered-accounts-modals/bulk-run-filtered-accounts/bulk-run-filtered-accounts.component'
import { BulkRunNotAllowedWarningModal } from './account-list-grid/bulk-run-filtered-accounts-modals/bulk-run-not-allowed-warning/bulk-run-not-allowed-warning-modal'
import { ForceReconTsWarningComponent } from './account-list-grid/bulk-run-filtered-accounts-modals/force-recon-timestamp-warning/force-recon-ts-warning.component'
import { AccountListPanelComponent } from './account-list-panel.component'
import { IssueCountStatusComponent } from './account-list-status-bar/issue-count-status-bar/issue-count-status.component'
import { AdvancedFiltersComponent } from './advanced-filters/advanced-filters.component'
import { RadioGroupFilterComponent } from './advanced-filters/radio-group-filter/radio-group-filter.component'
import { SecurityFilterComponent } from './advanced-filters/security-filter/security-filter.component'
import { AccountListService } from './services/account-list.service'
import { HttpAccountListService } from './services/http-account-list.service'
import { ApprovalsRequestFailedAccountsComponent } from './account-list-grid/bulk-run-filtered-accounts-modals/approvals-request-failed-accounts/approvals-request-failed-accounts.component'
import { OmegaTimestampStatusComponent } from './account-list-status-bar/omega-timestamp-status-bar/omega-timestamp-status.component'
import { ConfigureBellModalComponent } from './account-list-status-bar/omega-timestamp-status-bar/configure-bell-modal/configure-bell-modal.component'
import { TotalRowsStatusComponent } from './account-list-status-bar/total-rows-status-bar/total-rows-status.component'

@NgModule({
  imports: [
    CommonModule,
    NfFormsModule,
    FormsModule,
    InlineEditModule,
    ReactiveFormsModule,
    TableLayoutModule,
    HttpClientModule,
    NgbModalModule,
    GridWrapperModule,
    RowActionsModule,
    NgbTooltipModule,
    ButtonModule,
    NgbDropdownModule,
    LoaderModule,
    DateModule,
    DatepickerModule,
    ToastModule,
    GenericComponentsModule,
    CommentsModule,
    FilterModalModule,
    NgbPopoverModule,
    TableModule,
    DaterangeModule,
    NgSelectModule,
  ],
  declarations: [
    AccountListPanelComponent,
    AccountListGridComponent,
    AdvancedFiltersComponent,
    RadioGroupFilterComponent,
    SecurityFilterComponent,
    AccountListAggregateDropdownComponent,
    IssueCountStatusComponent,
    AccountListFilterActionsComponent,
    BulkRunFilteredAccountsComponent,
    BulkRunFilteredAccountsConfirmationModal,
    ForceReconTsWarningComponent,
    BulkRunNotAllowedWarningModal,
    ApprovalsRequestFailedAccountsComponent,
    OmegaTimestampStatusComponent,
    ConfigureBellModalComponent,
    TotalRowsStatusComponent,
  ],
  exports: [AccountListPanelComponent, AccountListGridComponent],
  providers: [
    { provide: AccountListService, useClass: HttpAccountListService },
  ],
})
export class AccountListModule {}

export { AccountListPanelComponent }
